import { Component, Input } from '@angular/core';
import { finalize } from 'rxjs';
import { UserService } from 'src/app/core/auth/user.service';
import { TaxDocDetail } from 'src/app/models/tax-doc-detail';
import { TaxDocSummary } from 'src/app/models/tax-doc-summary';
import { inOutAnimation } from 'src/app/shared/animations/in-out.animation';
import { EmailClient } from 'src/app/TaxDocNotifier-api';

@Component({
  selector: 'app-details-table',
  templateUrl: './details-table.component.html',
  styleUrl: './details-table.component.scss',
  animations: [inOutAnimation]
})
export class DetailsTableComponent {
  @Input() loadId: number;
  @Input() taxDocSummary: TaxDocSummary;
  @Input() rows: TaxDocDetail[] = null;
  @Input() searchNotFound: boolean;
  @Input() pageSearchLoading: boolean;
  @Input() searchError: boolean;

  taxDocDetails: TaxDocDetail[] = null;
  searchRow: TaxDocDetail[] = null;

  previewLoading: boolean = false;
  previewSuccess: boolean = false;
  previewFailure: boolean = false;

  name: string;
  previewAccountNumber: string;
  previewText: string;

  constructor(
    private emailClientService: EmailClient,
    private userService: UserService
  ) { }

  sendTestEmail(taxDocDetail: TaxDocDetail): void {
    this.previewLoading = true;
    this.previewAccountNumber = taxDocDetail.accountNumber;

    this.userService.getUser()
      .subscribe({
        next: res => {
          this.name = res.name;
        }
      });

    this.emailClientService.sendTestEmail(taxDocDetail, this.taxDocSummary.taxDoc, this.taxDocSummary.taxYear, this.loadId)
      .pipe(finalize(() => {
        this.previewLoading = false;
      }))
      .subscribe({
        next: res => {
          this.previewSuccess = res.success;
          this.previewFailure = !res.success;
          this.previewText = res.message;

          if (!res.message && !res.success)
          {
            this.previewText = 'An error occured previewing. Please try again later.';
          }
          else if (res.success)
          {
            this.previewText = `Test email for ${taxDocDetail.accountNumber} sent to ${this.name}@rwbaird.com.`
          }
        },
        error: () => {
          this.previewFailure = true;
          this.previewSuccess = false;
          this.previewText = 'An error occured previewing. Please try again later.';
        }
      });
  }

  dismissPreview(): void {
    this.previewSuccess = false;
    this.previewFailure = false;
  }

  dismissAccountSearchError(): void {
    this.searchError = false;
  }
}
